import type {
  LockBoxPublicInfoModel,
  SelfTourFeedback,
  SelfTourInstructionsRequest,
  SelfTourLockUpMedia,
  SelfTourSlot,
  SelfTourVisitModel,
} from 'src/features/self-tour-visit/types';
import type { BlobUploadResponse } from 'src/api/models';
import { apiClient } from 'src/utils/api-client';
import type { ApiClient } from 'src/utils/api-client';

export function fetchSelfTourVisitService(
  tourId: string,
  client: ApiClient = apiClient,
) {
  return client.get<SelfTourVisitModel>(`/self-tour-visits/${tourId}`);
}

export function fetchSelfTourAccessInstructionsService(
  tourId: string,
  instructions: SelfTourInstructionsRequest,
  client: ApiClient = apiClient,
) {
  const {
    coordinates,
    geolocationApiNotSupported,
    ignoreLocationCheck,
    ignoreTimeCheck,
  } = instructions;
  const selfTourInstructions: Record<string, unknown> = {};

  if (coordinates) {
    selfTourInstructions.coordinates = coordinates;
  } else if (geolocationApiNotSupported && !ignoreLocationCheck) {
    selfTourInstructions.geolocationApiNotSupported = true;
  }

  if (ignoreLocationCheck) {
    selfTourInstructions.ignoreLocationCheck = true;
  }

  if (ignoreTimeCheck) {
    selfTourInstructions.ignoreTimeCheck = true;
  }

  return client.post<LockBoxPublicInfoModel>(
    `/residents/tours/${tourId}/access-instructions`,
    { selfTourInstructions },
  );
}

export function submitSelfTourLockUpService(
  tourId: string,
  media: SelfTourLockUpMedia[],
  client: ApiClient = apiClient,
) {
  return client.post<void>(`/self-tour-visits/${tourId}/lock-up`, { media });
}

export function submitSelfTourFeedbackService(
  tourId: string,
  feedback: SelfTourFeedback,
  client: ApiClient = apiClient,
) {
  return client.post<void>(`/self-tour-visits/${tourId}/feedback`, feedback);
}

export function fetchFeedbackPhotoUploadUrlsService(
  tourId: string,
  numberOfMedia: number,
  client: ApiClient = apiClient,
) {
  return client.get<BlobUploadResponse[]>(
    `/self-tour-visits/${tourId}/feedback/media/upload-url?numberOfMedia=${numberOfMedia}`,
  );
}

export function fetchSelfTourSlotsService(
  homeId: string,
  client: ApiClient = apiClient,
) {
  return client.get<SelfTourSlot[]>(`/homes/${homeId}/tours/SelfTour`);
}

export function rescheduleSelfTourService(
  tourId: string,
  slot: { startOn: string; endOn: string },
  client: ApiClient = apiClient,
) {
  return client.put<void>(
    `/residents/tours/self-tour/${tourId}/reschedule`,
    slot,
  );
}
